angular.module('dnecom').service('ProductUtils', ["$http", "notifications", "$uibModal", "$confirm", function($http, notifications, $uibModal, $confirm) {
    this.getProduct = function() {
        var product = TemplateData.value('product');

        var defaults = {
            id: 0,
            properties: {
                base: {
                    robots: 'index, follow'
                },
                details: {},
                salesTerms: {
                    buttonType: 'standard',
                    button: 1
                },
                timer: {
                    type: 'none'
                }
            },
            variants: [{
                    id: '',
                    name: '',
                    regularPrice: 0.00,
                    currentPrice: 0.00
                }],
            shippingZones: [],
            gallery: [],
            status: 'public',
            ogImage: {},
            watermarkEnabled: false,
            watermarkType: null,
            watermarkContentType: null,
            watermarkBackgroundColor: null,
            directlyToCheckout: 0,
            directlyToCheckoutPopup: 0,
            directlyToCheckoutSettings: null
        };

        return angular.merge(defaults, product);
    };

    this.save = function(store, product, callback) {
        product = angular.copy(product);

        if (product.currentPrice === null || product.currentPrice === '') {
            product.currentPrice = product.regularPrice;
        }

        var data = {
            id: product.id,
            storeId: store.id,
            category: product.category,
            googleProductCategory: product.googleProductCategory,
            name: product.name || '',
            title: product.title || '',
            instructionSave: product.instructionSave,
            instruction: product.instruction,
            instructionText: product.instructionText,
            regularPrice: product.regularPrice,
            currentPrice: product.currentPrice,
            quantity: product.quantity,
            code: product.code || '',
            slug: product.slug || '',
            description: product.description || '',
            plainDescription: product.plainDescription || '',
            extraDescription: product.extraDescription || '',
            properties: product.properties,
            shippingZones: _.map(product.shippingZones, function(zone) {
                return {
                    id: zone.id,
                    shippingZoneId: zone.shippingZoneId,
                    priceRanges: zone.priceRanges
                };
            }),
            variants: product.variants,
            gallery: product.gallery,
            attributes: product.attributes,
            status: product.status,
            ogImage: product.ogImage,
            relatedProducts: product.relatedProducts,
            linkedProduct: product.linkedProduct,
            ogImageFrame: product.ogImageFrame,
            framedOgImage: product.framedOgImage,
            watermarkEnabled: product.watermarkEnabled,
            watermarkType: product.watermarkType,
            watermarkContentType: product.watermarkContentType,
            watermarkBackgroundColor: product.watermarkBackgroundColor,
            directlyToCheckout: product.directlyToCheckout,
            directlyToCheckoutPopup: product.directlyToCheckoutPopup,
            directlyToCheckoutSettings: product.directlyToCheckoutSettings,
        };

        return $http
            .put(Routing.generate('products_update', {
                store: store.id,
                productId: product.id || 0
            }), data)
            .then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message || 'Invalid server response.');
                }
                callback(response);
            }, function(response) {
                if (response.data && response.data.errors) {
                    callback(response);
                } else {
                    notifications.danger('Request error.');
                }
            });
    };

    this.delete = function (store, product) {
        const deleteCheckRoute = Routing.generate('products_delete_check', {
            id: store.id,
            product: product.id
        });
        const deleteRoute = Routing.generate('products_delete', {
            id: store.id,
            productId: product.id
        });

        return $http.get(deleteCheckRoute)
            .then((response) => {
                if (response.data.success) {
                    return
                }

                $uibModal.open({
                    templateUrl: 'alert-modal.html',
                    controller: 'AlertModalInstanceCtrl',
                    controllerAs: '$ctrl',
                    resolve: {
                        message: () => response.data.message || 'Failed to delete product.',
                        upsells: () =>response.data.upsells,
                        store: () => store,
                    }
                });

                return Promise.reject('cancel')
            })
            .then(() => $confirm({ text: 'Do you really want to delete selected product?' }))
            .then(() => $http.delete(deleteRoute))
            .then((response) => {
                if (!response.data.success) {
                    throw response.data
                }

                notifications.success('Product deleted.');

                return Promise.resolve(true)
            })
            .catch((error) => {
                if (error === 'cancel') { return Promise.reject(error) }

                notifications.danger('Request error.');
                console.error(error);

                return Promise.reject(error);
            });
    };

    return this;
}]);
